import React from 'react';
import PropTypes from 'prop-types';
import StripeCreditCardProp from '../../../../payments/propTypes/StripeCreditCardProp';

function CreditCardItem({
  t,
  idx,
  creditCard,
  isSelected,
  onSelectCard,
  onRemoveCard,
}) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for
    <label key={creditCard.id} className="card-container">
      <input
        type="radio"
        name="credit-card"
        checked={isSelected}
        onChange={() => onSelectCard(creditCard.id)}
      />
      <span className="custom-radio" />

      <div className="card-details">
        <div className="card-number">
          **** **** **** {creditCard.last4}
          <img alt={`${creditCard.brand} logo`} src={creditCard.logo} />
        </div>
        <div className="card-expiry">{`${t('expires_at')} ${
          creditCard.exp_month
        }/${creditCard.exp_year}`}</div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/control-has-associated-label */}
      <button
        type="button"
        tabIndex={idx}
        onClick={() => {
          onRemoveCard(creditCard.id);
        }}
        className="btn btn-metal m-btn m-btn--icon
                              m-btn--icon-only m-btn--custom m-btn--pill"
      >
        <i className="fa fa-trash-alt" />
      </button>
    </label>
  );
}

CreditCardItem.propTypes = {
  t: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  creditCard: PropTypes.shape(StripeCreditCardProp.propType).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelectCard: PropTypes.func.isRequired,
  onRemoveCard: PropTypes.func.isRequired,
};

CreditCardItem.defaultProps = {};

export default CreditCardItem;
